import { render, staticRenderFns } from "./specialMsg.vue?vue&type=template&id=27081df0&scoped=true&"
import script from "./specialMsg.vue?vue&type=script&lang=js&"
export * from "./specialMsg.vue?vue&type=script&lang=js&"
import style0 from "./specialMsg.vue?vue&type=style&index=0&id=27081df0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27081df0",
  null
  
)

export default component.exports